import { styled, Box, Stack, Typography, TextField } from '@mui/material'
import { Card, CardHeader } from 'components'

export const Container = styled(Stack)`
  gap: 10px;
  height: 100%;
`
export const PageWrapper = styled(Stack)`
  flex-direction: row;
  width: 100%;
  flex: 1;
  gap: 10px;
`
export const SectionCard = styled(Card)`
  flex: 4;
  display: flex;
  flex-direction: column;
`
export const StyledCardHeader = styled(CardHeader)`
  padding: 0 20px;
`
export const SectionTitle = styled(Typography)`
  font-weight: bold;
  font-size: 22px;
`
export const TableContainer = styled(Box)`
  padding: 0 8px;
  overflow: auto;
`

export const DetailsPageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
`
export const DetailsPageMainContent = styled(Box)`
  display: flex;
  gap: 16px;
  flex: 1;
  overflow: auto;
  flex-wrap: wrap;
`
export const DetailsPageSection = styled(Stack)`
  gap: 16px;
  flex: 1;
`

export const DetailsPageActionsContainer = styled(Stack)`
  height: 96px;
  justify-content: center;
  padding: 0 20px;
`

export const DetailsPageActionsButtons = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
`

export const Attributes = styled(Stack)`
  flex: 2;
  justify-content: center;
  padding-left: 8px;
`

export const AttributeItem = styled(Stack)`
  flex-direction: row;
  gap: 10px;
  align-items: center;
`

export const AttributeLabel = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  text-align: left;
`

export const AttributeValue = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
`

export const ButtonsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 25px;
`
export const LoadingContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 400px;
  align-items: center;
`

export const BlendNameContainer = styled(Card)`
  padding: 16px;
  font-size: 20px;
  font-weight: 800;
  color: ${({ theme }) => theme.palette.text.primary};
`

export const CustomBlendName = styled(TextField)(({ theme }) => ({
  marginTop: '5px',
  marginBottom: '15px',
  '& .MuiInputLabel-root': {
    color: theme.palette.grey[500],
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.grey[300],
    },
  },
}))

export const ModalBody = styled(Box)`
  padding: 8px 32px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`
